import React from 'react';
import PropTypes from 'prop-types';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';

import XstarTau from '../../../FormFields/XstarTau';
import MedianEF from '../../../FormFields/MedianEF';
import LikelihoodParams from '../../../LikelihoodParams';
import FullWidthFormControl from '../../../FormFields/FullWidthFormControl';

const LikelihoodParamsNonHomogeneousLognormal = (props) => {
  const getSuggestions = () => {
    return (
      <FullWidthFormControl>
        <InputLabel shrink htmlFor="likelihood_params_names-helper">Likelihood Parameter Type</InputLabel>
        <Select
          value={props.selected.params_type}
          onChange={e => props.onUpdateLikelihoodParamsType(e, e.target.value)}
          input={<Input name="likelihood_params_names" id="likelihood_params_names-helper" />}
        >
          <MenuItem value="Median & Error-Factor">Median & Error-Factor</MenuItem>
          <MenuItem value="X-Star & Tau">X-Star & Tau</MenuItem>
        </Select>
      </FullWidthFormControl>
    );
  };

  const getOptions = (val) => {
    const { values } = props.selected.params;
    switch (val) {
      case 'Median & Error-Factor':
        return values.map((value, idx) => {
          return (<MedianEF
            index={idx}
            onUpdate={props.onUpdateLikelihoodParamsValues}
            onRemove={props.onRemoveLikelihoodParamsValues}
            selected={value}
          />);
        });
      default:
      case 'X-Star & Tau':
        return values.map((value, idx) => {
          return (<XstarTau
            index={idx}
            onUpdate={props.onUpdateLikelihoodParamsValues}
            onRemove={props.onRemoveLikelihoodParamsValues}
            selected={value}
          />);
        });
    }
  };

  return (
    <LikelihoodParams
      options={getOptions(props.selected.params_type)}
      suggestions={getSuggestions()}
      addValue={props.onAddLikelihoodParamsValues}
      onAddLikelihoodParamsComponentResult={props.onAddLikelihoodParamsComponentResult}
      onRemoveLikelihoodParamsComponentResult={props.onRemoveLikelihoodParamsComponentResult}
      addList={props.onAddLikelihoodParamsList}
    />
  );
};

LikelihoodParamsNonHomogeneousLognormal.propTypes = {
  onUpdateLikelihoodParamsType: PropTypes.instanceOf(Function).isRequired,
  onAddLikelihoodParamsValues: PropTypes.instanceOf(Function).isRequired,
  onAddLikelihoodParamsList: PropTypes.instanceOf(Function).isRequired,
  onRemoveLikelihoodParamsValues: PropTypes.instanceOf(Function).isRequired,
  onUpdateLikelihoodParamsValues: PropTypes.instanceOf(Function).isRequired,
  selected: PropTypes.shape({
    params_type: PropTypes.string,
    params: PropTypes.shape({
      component_result: PropTypes.arrayOf(Number).isRequired,
      values: PropTypes.arrayOf(PropTypes.arrayOf(Number)).isRequired,
    }).isRequired,
  }).isRequired,
};

export default LikelihoodParamsNonHomogeneousLognormal;
